import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

function VerticalPresentationIcon(props) {
  return (
    <SvgIcon {...props} viewBox='0 0 32 32'>
      {/* Left Frames (Three stacked webcam frames) */}
      <rect
        x='0'
        y='5'
        width='6'
        height='4'
        rx='0'
        fill='white'
        stroke='white'
        strokeWidth='2'
      />
      <rect
        x='0'
        y='13'
        width='6'
        height='4'
        rx='0'
        fill='white'
        stroke='white'
        strokeWidth='2'
      />
      <rect
        x='0'
        y='21'
        width='6'
        height='4'
        rx='0'
        fill='white'
        stroke='white'
        strokeWidth='2'
      />
      {/* Right Frame (Screenshare) */}
      <rect
        x='9'
        y='4'
        width='22'
        height='22'
        rx='2'
        fill='none'
        stroke='white'
        strokeWidth='2'
      />
    </SvgIcon>
  );
}

export default VerticalPresentationIcon;
